import store from '@/store';
import { isWorkflowCatalogRestricted } from '@/config/workflowCatalog';

// Run after AuthGuard so a direct page load has the user's role available.
export const WorkflowCatalogGuard = (to, from, next) => {
    const profile = store.getters.profile;
    const user = profile && profile.data ? profile.data.user : null;
    if (isWorkflowCatalogRestricted(user)) {
        return next({ path: '/workflows', replace: true });
    }
    next();
};
